import { Signal, useSignal, useSignalEffect } from "@preact/signals-react";
import { log } from "../library/logger";
import { moduleImportMap } from "../loaders/moduleLoader";

function isValidModule(value: any): boolean {
  return value !== null && value !== undefined && typeof value === "object";
}
const moduleCache = new Map<string, any>();
export function useDynamicImport<T = any>(moduleName: string, tag: string): Signal<T | null> {
  const cachedModule = moduleCache.get(moduleName);
  const initialData = isValidModule(cachedModule) ? cachedModule : null;

  const importedData = useSignal<T | null>(initialData);

  useSignalEffect(() => {
    const loader = moduleImportMap[moduleName];
    if (!loader) {
      log.error(tag, `No loader found for key: ${moduleName}`);
      return;
    }

    const cached = moduleCache.get(moduleName);
    if (isValidModule(cached)) {
      importedData.value = cached;
      return;
    }

    (async () => {
      try {
        const m = await loader();
        const validModule = isValidModule(m) ? m : null;
        moduleCache.set(moduleName, validModule);
        importedData.value = validModule;
      } catch (error) {
        log.error(tag, "Dynamic import error:", error);
      }
    })();
  });

  return importedData;
}
